import React, { useEffect, useState } from 'react'
import { useSnackbar } from 'notistack'
import SideDrawer from '../../../components/SideDrawer'
import AddLocation from '../../../components/locations/addLocation'
import { errorText, fetchPickupNames, savePickupLocation } from '../ptlSetupApi'

/**
 * Add a B2B pickup location for one merchant from PTL Merchant Setup, with the merchant already chosen. Same form and
 * save as Merchant Setup → Pickup Locations (components/locations/addLocation + merchant/register_pickup), so the two
 * stay the same; that page picks merchants from a cached KYC-approved list, which this avoids. onSaved() reloads.
 */
export default function AddPickupDrawer({ merchant, open, onClose, onSaved }) {
  const { enqueueSnackbar } = useSnackbar()
  const [busy, setBusy] = useState(false)
  const [names, setNames] = useState([])

  // Existing names, so the form's "Location name already exists" check works as on Pickup Locations.
  useEffect(() => {
    if (!open || !merchant?.id) return
    fetchPickupNames(merchant.id).then(setNames).catch(() => setNames([]))
  }, [open, merchant?.id])

  const save = (data) => {
    setBusy(true)
    savePickupLocation(merchant.id, data)
      .then(() => {
        enqueueSnackbar(`Pickup location ${data.name} added for ${merchant.name}`, { variant: 'success' })
        onClose()
        onSaved()
      })
      .catch((e) => enqueueSnackbar(errorText(e, 'Could not add the pickup location'), { variant: 'error' }))
      .finally(() => setBusy(false))
  }

  return (
    <SideDrawer open={open} setOpen={() => { if (!busy) onClose() }} drawerWidth='70%' title={`Add pickup location · ${merchant?.name || ''}`}
      children={open ? <AddLocation show={open} formLoading={busy} handleData={save} currentId={null} activeTab='B2B' existingLocationNames={names} /> : null} />
  )
}
